enum TargetTeleSalesPermission {
  Prem_Target_Tele_Sales_View = 'Prem_Target_Tele_Sales_View',
  Prem_Target_Tele_Sales_Create = 'Prem_Target_Tele_Sales_Create',
  Prem_Target_Tele_Sales_Edit = 'Prem_Target_Tele_Sales_Edit',
  Prem_Target_Tele_Sales_Delete = 'Prem_Target_Tele_Sales_Delete',
  Prem_Target_Tele_Sales_Approve = 'Prem_Target_Tele_Sales_Approve',
  Prem_Target_Tele_Sales_Manage_All_Retail = 'Prem_Target_Tele_Sales_Manage_All_Retail',
  Prem_Target_Tele_Sales_Manage_All_WholeSale = 'Prem_Target_Tele_Sales_Manage_All_WholeSale',
}

export default TargetTeleSalesPermission;
